/**
 * 객체 설정 > 서비스 객체 Store
 *
 * @since 2021-08-19
 * @author wj-tams-dev01
 */

// TAMS
import {ObjectSecProfileApiPrefix as objApiPrefix, CmApiPrefix as cmApiPrefix} from 'utils'
import {isPreDefine} from 'objectSettingsUtils'

// <editor-fold desc="Util Function">
// 서비스 유형
const serviceCategorys = [
  {value: 0, label: 'None'},
  {value: 1, label: 'HTTP'},
  {value: 2, label: 'SMTP'},
  {value: 3, label: 'POP3'},
  {value: 4, label: 'FTP'},
  {value: 5, label: 'H.323'},
  {value: 6, label: 'SQLNET'},
  {value: 7, label: 'HTTPS'},
  {value: 8, label: 'SMTPS'},
  {value: 9, label: 'POP3S'},
  {value: 10, label: 'SSL'},
  {value: 11, label: 'RMI'},
  {value: 12, label: 'SIP'},
  {value: 13, label: 'TFTP'},
  {value: 14, label: 'IMAP'},
  {value: 15, label: 'IMAPS'},
  {value: 16, label: 'TELNET'},
  {value: 17, label: 'DNS'},
  {value: 18, label: 'ORACLE'},
  {value: 19, label: 'FTPS'}
]

// 서비스 유형 (SSL 복호화 메뉴)
const sslServiceCategorys = [
  {value: 7, label: 'HTTPS'},
  {value: 8, label: 'SMTPS'},
  {value: 9, label: 'POP3S'},
  {value: 10, label: 'SSL'},
  {value: 15, label: 'IMAPS'}
]

// 서비스 객체 데이터
const initServiceData = () => {
  return {
    // TAMS
    srv_obj_uname: '',
    srv_obj_cate_type: 0,
    srv_obj_src_port_exp: '*',
    srv_obj_dst_port_exp: null,
    srv_obj_life_time_num: 1800,
    srv_obj_prio_num: 1,
    srv_obj_desc: '',
    srv_obj_pre_def_yn: 0,
    prtc_obj_id: 5,
    cfg_layer: 1
  }
}

// 서비스 Any 객체 데이터
const initAnyServiceData = () => {
  return {
    name: void 0,
    desc: void 0,
    tcp: 1800,
    udp: 1800,
    icmp: 1800,
    others: 1800
  }
}
// </editor-fold>

export const state = () => ({
  // NGIPS용
  serviceApi: `${cmApiPrefix}/objects/ips/srv`,
  serviceCategoryOpts: serviceCategorys,
  sslServiceCategoryOpts: sslServiceCategorys,
  protocolData: [],
  // protocolList: [],
  parseProtocolList: [],
  // END...
  serviceData: initServiceData(),
  anyServiceData: initAnyServiceData(),
  serviceObjectDataList: [],
  parseServiceCategory: [],
  serviceCategory: [],
  selectedData: void 0,
  copyData: void 0
})

export const mutations = {
  serviceClear (state) {
    state.serviceObjectDataList = []
    state.protocolData = []
    state.selectedData = void 0
    state.copyData = void 0
  },

  // 프로토콜 목록 초기화
  resetProtocolList (state) {
    state.protocolList = []
  },
  // 프로토콜 조회
  setProtocolList (state, data) {
    const parseProtocolList = _.map(data, (value) => {
      return {
        label: value.prtc_obj_uname,
        value: value.prtc_obj_id,
        // TAMS
        prtc: value.prtc_obj_prtc
      }
    })
    state.parseProtocolList = Object.freeze(parseProtocolList)
    state.protocolData = Object.freeze(data)
  },
  // 서비스 유형 조회
  setServiceCategory (state, data) {
    const parseServiceCategory = _.map(data, (value) => {
      const key = _.keys(value)[0]
      return {
        label: key,
        value: value[key],
        use_tcp: value.use_tcp,
        use_udp: value.use_udp
      }
    })
    state.parseServiceCategory = Object.freeze(parseServiceCategory)
    state.serviceCategory = Object.freeze(data)
  },

  resetServiceCopyData (state) {
    state.copyData = void 0
  },

  // 서비스 객체 초기화
  resetServiceObjectData (state) {
    state.serviceData = initServiceData()
    state.anyServiceData = initAnyServiceData()
  },

  // 서비스 객체 목록 조회
  setServiceObjectDataList (state, data) {
    state.serviceObjectDataList = Object.freeze(data)
  },

  // 서비스 객체 목록 초기화
  resetServiceObjectDataList (state) {
    state.serviceObjectDataList = []
  },

  // 서비스 객체 저장
  setServiceObjectData (state, data) {
    const serviceObjectDataList = _.cloneDeep(state.serviceObjectDataList)
    let itemIndex = _.findIndex(state.serviceObjectDataList, {prio: data.prio})

    if (itemIndex < 0) {
      itemIndex = 1
    }

    serviceObjectDataList.splice(itemIndex, 0, data)

    // 우선 순위 업데이트
    // _.forEach(serviceObjectDataList, (o, i) => {
    //   if (o.prio && i > itemIndex) {
    //     _.assign(o, {
    //       prio: o.prio + 1
    //     })
    //   }
    // })

    state.serviceObjectDataList = Object.freeze(serviceObjectDataList)
  },

  // 서비스 객체 선택
  selectedObjectData (state, data) {
    state.selectedData = data
  },

  // 선택된 객체 초기화
  resetServiceSelectedData (state) {
    state.selectedData = void 0
  },

  // 서비스 객체 조회
  getServiceObjectData (state, data) {
    // TAMS
    state.serviceData = data
  },

  // 서비스 객체 수정
  updateServiceObjectData (state, data) {
    state.serviceObjectDataList = Object.freeze(_.map(state.serviceObjectDataList, (o) => {
      if (o.srv_obj_id === data.srv_obj_id) {
        o = data
      }

      return o
    }))
  },

  // 서비스 객체 삭제
  deleteServiceObjectData (state, data) {
    const serviceObjectDataList = _.cloneDeep(state.serviceObjectDataList)
    const itemIndex = _.findIndex(serviceObjectDataList, {srv_obj_id: data})

    serviceObjectDataList.splice(itemIndex, 1)

    // 우선 순위 업데이트
    // _.forEach(serviceObjectDataList, (o, i) => {
    //   if (o.prio && i >= itemIndex) {
    //     _.assign(o, {
    //       prio: o.prio - 1
    //     })
    //   }
    // })

    state.serviceObjectDataList = Object.freeze(serviceObjectDataList)
  },

  // 서비스 객체 일괄 삭제
  deleteBatchServiceObjectData (state, data) {
    const serviceObjectDataList = _.cloneDeep(state.serviceObjectDataList)

    _.forEach(data, (o) => {
      const itemIndex = _.findIndex(serviceObjectDataList, {srv_obj_id: o.srv_obj_id})

      serviceObjectDataList.splice(itemIndex, 1)
    })

    // 우선 순위 업데이트
    // _.forEach(serviceObjectDataList, (o, i) => {
    //   if (o.prio && i >= 1) {
    //     _.assign(o, {
    //       prio: i
    //     })
    //   }
    // })

    state.serviceObjectDataList = Object.freeze(serviceObjectDataList)
  },

  // 서비스 유형 초기화
  initServiceCate (state) {
    // TAMS
    state.serviceData.srv_obj_cate_type = 0
  }
}

export const actions = {
  // 프로토콜 목록 조회
  async getProtocolList ({commit, state}, {loadingShow = true, loadingHide = true} = {}) {
    // TAMS
    const {code, result} = await this.$axios.$get(`${cmApiPrefix}/objects/ips/prtc`, {
      loadingShow,
      loadingHide
    })

    if (code === 'ok') {
      commit('setProtocolList', result)
    }
  },
  // 서비스 유형 조회
  async getServiceCategory ({commit}, {target = void 0, loadingShow = false, filter, loadingHide = true} = {}) {
    // TAMS
    const {code, result} = await this.$axios.$get(`${cmApiPrefix}/objects/srv/categories`, {
      loadingShow,
      loadingHide
    })

    if (code === 'ok') {
      commit('setServiceCategory', result)
    }
  },

  // 서비스 객체 목록 조회
  async getServiceObjectList ({commit, dispatch, state}, {target = void 0, loadingShow = true, loadingHide = true} = {}) {
    const {code, result} = await this.$axios.$get(
      `${cmApiPrefix}/objects/ips/srv`,
      {loadingShow, loadingHide}
    )

    if (code === 'ok') {
      commit('setServiceObjectDataList', result)
    }
  },

  // 서비스 객체 저장
  // TAMS
  async saveServiceObjectData ({commit, dispatch, state}, {forceYn = 0, loadingShow = true, loadingHide = true, successAlert = true} = {}) {
    const serviceData = state.serviceData
    // TAMS
    serviceData.srv_obj_desc = _.isUndefined(serviceData.srv_obj_desc) ? '' : serviceData.srv_obj_desc
    serviceData.force_yn = forceYn

    // TAMS
    const res = await this.$axios.$post(`${cmApiPrefix}/objects/ips/srv`, serviceData, {
      loadingShow,
      loadingHide,
      successAlert
    })
    return res
  },

  // 서비스 객체 수정
  // TAMS
  async updateServiceObjectData ({commit, state, dispatch, rootState}, {forceYn = 0, loadingShow = true, loadingHide = true, successAlert = true} = {}) {
    const data = state.serviceData

    // TAMS
    data.srv_obj_desc = _.isUndefined(data.srv_obj_desc) ? '' : data.srv_obj_desc
    data.force_yn = forceYn

    // TAMS
    const res = await this.$axios.$put(`${cmApiPrefix}/objects/ips/srv`, data, {
      loadingShow,
      loadingHide,
      successAlert
    })

    return res
  },

  // 서비스 객체 조회
  async getServiceObjectData ({commit, state}, {loadingShow = true, loadingHide = true} = {}) {
    const objectId = state.selectedData.srv_obj_id
    // TAMS
    const
      srvObjType = 1 // 서비스 객체 유형, 1 서비스 객체, 2 서비스 그룹 객체, 0인 경우 전체 조회
    const {code, result} = await this.$axios.$get(`${cmApiPrefix}/objects/srv/${objectId}/${srvObjType}`, {loadingShow, loadingHide})

    if (code === 'ok') {
      commit('getServiceObjectData', result[0])
    }
  },

  // 서비스 객체 삭제
  // TAMS 미사용 (단일, 다수 관계 없이 동일 API 사용)
  async deleteServiceObjectData ({commit, dispatch, state}, {loadingShow = true, loadingHide = true} = {}) {
    const objectId = state.selectedData.srv_obj_id
    if (isPreDefine(state.selectedData)) {
      return {isPreDefine: true}
    }
    let code = void 0
    let cause = void 0
    try {
      const response = await this.$axios.$delete(`${objApiPrefix}/service/objects/${objectId}`, {isReturnError: true, loadingShow, loadingHide})
      code = _.get(response, ['code'])
    } catch (e) {
      code = _.get(e, ['data', 'code'])
      cause = _.get(e, ['data', 'message'])
    }

    if (code === 'ok') {
      commit('deleteServiceObjectData', objectId)
      commit('resetServiceSelectedData')

      return true
    } else if (Number(code) === 15010) {
      const selectedData = _.cloneDeep(state.selectedData)
      return {
        notDelete: [],
        forceDelete: [_.assign(selectedData, {cause: cause})]
      }
    } else {
    // } else if (Number(code) === 12004 || Number(code) === 15011) {
      const selectedData = _.cloneDeep(state.selectedData)
      return {
        notDelete: [_.assign(selectedData, {cause: cause})],
        forceDelete: []
      }
    }
  },

  // 서비스 객체 일괄 삭제
  // TAMS
  // 서비스 그룹객체도 사용함.
  // 서비스 그룹의 경우 groupObject의 store를 사용하여 표현하나 삭제 후 TAMS의 경우 GUI 작업 없이 다시 Reload 되기 때문에 문제 없음
  // 동일 API 중복으로 인한 유지관리 이원화를 막기 위해 같은 Action을 사용함.
  async deleteBatchServiceObjectData ({commit, dispatch, state}, {items, forceYn = 0} = {}) {
    // TAMS
    let url = `objects/ips/srv`,
      params = void 0,
      srvObjIdList = []
    const id = 'srv_obj_id'

    const selectedData = _.cloneDeep(items)
    if (_.size(selectedData) > 0) {
      srvObjIdList = _.map(selectedData, item => item[id])
    } else {
      srvObjIdList = [selectedData[id]]
    }

    if (_.size(srvObjIdList) === 1) {
      url += `/${srvObjIdList[0]}`
    } else {
      params = {
        items: srvObjIdList,
        force_yn: forceYn
      }
    }

    const res = await this.$axios.$delete(
      `${cmApiPrefix}/${url}`,
      {data: params},
      {successAlert: false}
    )

    if (res.code === 'ok') {
      commit('resetServiceSelectedData')
    }
    return res
  }
}

export const getters = {}

export const strict = false
